export { default } from './VerticalBarChart.component';
export type { VerticalBarChartEntry, VerticalBarChartProps } from './VerticalBarChart.component';
